import _isNil from "lodash/isNil";
import { formatCurrency, formatPercent } from '@nerdwallet/nw-client-lib/num';

var getMortgagesSBSCDrivers = function getMortgagesSBSCDrivers(mortechData) {
  var mortgageDrivers = [];

  if (!_isNil(mortechData === null || mortechData === void 0 ? void 0 : mortechData.apr)) {
    mortgageDrivers.push({
      id: 'apr',
      label: 'APR',
      value: formatPercent(mortechData.apr, '0.000%'),
      valueSize: 'medium'
    });
  }

  if (!_isNil(mortechData === null || mortechData === void 0 ? void 0 : mortechData.interestRate)) {
    mortgageDrivers.push({
      id: 'interestRate',
      label: 'Interest Rate',
      value: formatPercent(mortechData.interestRate, '0.000%'),
      valueSize: 'medium'
    });
  }

  if (!_isNil(mortechData === null || mortechData === void 0 ? void 0 : mortechData.payment)) {
    var _mortechData$payment;

    mortgageDrivers.push({
      id: 'payment',
      label: 'Monthly Payment',
      value: formatCurrency((_mortechData$payment = mortechData.payment) === null || _mortechData$payment === void 0 ? void 0 : _mortechData$payment.total),
      valueSize: 'medium'
    });
  }

  if (!_isNil(mortechData === null || mortechData === void 0 ? void 0 : mortechData.fees)) {
    var _mortechData$fees;

    mortgageDrivers.push({
      id: 'totalfees',
      label: 'Total Fees',
      value: formatCurrency((_mortechData$fees = mortechData.fees) === null || _mortechData$fees === void 0 ? void 0 : _mortechData$fees.total),
      valueSize: 'medium'
    });
  }

  return mortgageDrivers;
};

export default (function (mortechData) {
  return {
    drivers: getMortgagesSBSCDrivers(mortechData)
  };
});